import { types as misc } from '../actions/misc'
import { actions as reports } from '../actions/reports'
import { actions as participants } from '../actions/participants'
import { actions as profiles } from '../actions/profiles'
import { actions as settings } from '../actions/settings'
import { actions as users } from '../actions/users'
import { actions as sessions } from '../actions/sessions'

// When the therapist logs out, the wiper wipes out everything related to them.
const wiper = (store) => {
    return (next) => {
        return (action) => {
            if (action.type === misc.WIPE_OUT) {
                store.dispatch(participants.resetParticipants())
                store.dispatch(sessions.resetSessions())
                store.dispatch(reports.resetReports())
                store.dispatch(profiles.resetProfile())
                store.dispatch(settings.resetSettings())
                store.dispatch(users.resetUser())
            }
            next(action)
        }
    }
}

export default wiper



// WEBPACK FOOTER //
// ./src/store/middlewares/wiper.js